module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_003.png
// module id = 1127
// module chunks = 0